module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-LASTFM.a22d1f70.png";